import React from 'react';
import { Card } from './Card';
import { IconWrap } from './IconWrap';
import { CiCircleInfo } from 'react-icons/ci';
import useTheme from '../hooks/useTheme';

export const PreviewDisclaimer: React.FC = () => {
    const { theme } = useTheme();

    return (
        <Card
            style={{
                marginBottom: '32px',
                padding: '12px 16px',
                backgroundColor: theme.background.panel,
                border: `1px solid ${theme.colors.line}`,
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
            }}
        >
            <IconWrap icon={<CiCircleInfo />} size={18} color="muted" />
            <p
                style={{
                    fontSize: '13px',
                    color: theme.text.muted,
                    margin: 0,
                    lineHeight: 1.5,
                }}
            >
                Some items are preview content for Phase 2/3 portal modules.
            </p>
        </Card>
    );
};

